export const PAYMENT_SUCCESS_MODAL_NAME = 'paymentSuccess';
